import { getApiClient } from './apiService'
import config from '../config/env'

const uploadImage = async data => {
  try {
    const headers = {
      Accept: 'multipart/formData',
    }

    const response = await getApiClient(headers).post('/upload-image', data)
    if (response.status === 201 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: true,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('uploadImage error: ', error)

    let errorMessage = error.message

    const responseMessage = error?.response?.data?.message
    if (responseMessage) {
      errorMessage = responseMessage
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const deleteImage = async imageId => {
  try {
    const response = await getApiClient().delete(`/images/${imageId}`)
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('deleteImage error: ', error)
    let errorMessage = error.message

    const responseMessage = error?.response?.data?.message
    if (responseMessage) {
      errorMessage = responseMessage
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

export const imageService = {
  uploadImage,
  deleteImage,
}
